import * as React from 'react';

import {graphql, navigate, useStaticQuery} from "gatsby";
import {useState} from "react";
import {translate} from "../../helpers/lang";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import {ExpertisesList} from "./expertisesList";
import {AnimatedText} from "./animatedText";


export const Project = ({lang ,PageData}) =>{

    const {bottomImg} = PageData;
    const {topImg} = PageData;
     const imageT = getImage(topImg?.nodes[0]?.childrenFile[0]);
     const imageB = getImage(bottomImg?.nodes[0]?.childrenFile[0]);
     const textTranslate = translate(lang , PageData?.dataText?.edges?.[0]?.node);
    const currentExp = PageData?.dataText?.edges?.[0]?.node?.expertises;
    const [openVideo , setOpenVideo] = useState(false)
    const data = useStaticQuery(graphql`
    {
      allHome {
        edges {
          node {
            data {
              projects {
                labels {
                  back_button {
                    en
                    fr
                  }
                  photo_credits_label {
                    en
                    fr
                  }
                  video_button {
                    en
                    fr
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

    const t = translate(lang , data.allHome.edges[0].node.data.projects.labels);


    return(
        <main className="main">
            <section className="project-hero">
                <div   className="project-img">
                  <div className="figure-webp">
                    <div className={'picture-webp'} >
                      <GatsbyImage objectFit={'cover'} alt={textTranslate('title_line_1')} image={imageT}   />
                    </div>
                  </div>
                </div>
                <div className="container">
                    <div className="project-hero__content">
                        <h1> {textTranslate('title_line_1')}
                          {textTranslate('title_line_2')&&<span>{textTranslate('title_line_2')}</span>}
                        </h1>
                      {  textTranslate('video', true)? <button onClick={() => {
                        setOpenVideo(true)
                      }} type="button"
                               className="button anim_button open-modal-video"
                               aria-label='open video modal'>
                        {t('video_button')}
                      </button>:""
                      }
                    </div>
                </div>
                {openVideo&&<button onClick={ ()=>setOpenVideo(false)} className="modal-video active">
                    <div className="modal-video__wrap">
                        <button className="modal-video__close" onClick={()=>{setOpenVideo(false)}} aria-label='close modal'/>
                        <iframe width="560" height="315" src= {"https://www.youtube-nocookie.com/embed/"+textTranslate('video', true)}
                                title="YouTube video player" frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen/>
                    </div>

                </button>}
            </section>
            <section className="project-description">
                <div className="container project-description__container">
                        <AnimatedText   textTranslate={textTranslate}/>
                       <ExpertisesList lang={lang}  currentExp={currentExp}/>
               </div>
            </section>
            <section className="animate__animated animate__fadeInUpBig">
                <div className="container">
                  {  textTranslate('credits',true )&&<p
                    className="project__photo-credits"> {t('photo_credits_label')} {textTranslate('credits', true)}</p>}
                </div>
              {imageB?<div className="project-img">
                <div className="figure-webp">
                  <div className={'picture-webp'} >
                    <GatsbyImage alt={textTranslate('title_line_1')} objectFit={'cover'} image={imageB}/>
                  </div>

                </div>
              </div> : <div style={{height:100}}/>}
                <div className="project__button project__button_top">
                    <button  onClick={() => navigate(-1)} className="button anim_button"> {t('back_button')}</button>
                </div>
            </section>
        </main>
    )
}
